<p>remotedb-type-service works!</p>
